import { getRgObjectsOfType as f, RG_TYPE as p, RgChildren as a } from "@project-rouge/rg-core";
function y(e, t, n) {
  const o = /* @__PURE__ */ new Map(), d = f(e, p.Building);
  if (d.length > 0)
    for (const i of d)
      for (const l of t) {
        const r = i.children.filter((s) => s.data.level === l), c = n.flatMap((s) => f(r, s));
        g(o, l, c);
      }
  else if ("rg" in e ? a.Building.includes(e.type) : e.some((i) => a.Building.includes(i.type))) {
    const i = "rg" in e ? [e] : e;
    for (const l of i) {
      const r = l.data;
      if (r && t.includes(r.level)) {
        const c = n.flatMap((s) => f(l, s));
        g(o, r.level, c);
      }
    }
  }
  return o;
}
function g(e, t, n) {
  n = Array.isArray(n) ? n : [n], e.set(t, [...e.get(t) || [], ...n]);
}
export {
  y as mapRgObjectsByLevels
};
//# sourceMappingURL=index6.js.map
